export default __webpack_public_path__ + "static/abcrightplain-ba3772e153edc812e96f60033ae64ad9.svg";